(function () {
    'use strict';
    angular.module('SMART2').factory('httpLoaderInterceptor', ['$rootScope', '$timeout', function ($rootScope, $timeout) {

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            $rootScope.pageLoaderFlagController = true;
        });

        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            //$timeout(function () {
                $rootScope.pageLoaderFlagController = false;
            //}, 2000);
        });

        var requestCount = 0;
        function startRequest(config) {
            if (!requestCount) {
                //$rootScope.pageLoaderFlagController = true;
            }
            requestCount++;
            return config;
        }
        function endRequest(arg) {
            if (!requestCount)
                return;
            requestCount--;
            if (!requestCount) {
                //$rootScope.pageLoaderFlagController = false;
            }
            return arg;
        }
        return {
            'request': startRequest,
            'requestError': endRequest,
            'response': endRequest,
            'responseError': endRequest
        };
    }]);

    angular.module('SMART2').config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('httpLoaderInterceptor');
    }]);

    angular.module('SMART2').directive('smartGlobalLoader', ['$timeout', '$translate', function ($timeout, $translate) {
        return {
            restrict: 'AE',
            replace: true,
            scope: {
                isFixed: '=?',
                config: '=?',
                onCancel: "&",
            },
            link: function (scope, element, attrs) {
            	var message = $translate.instant("loadingMsg");
            	
                scope.conf = angular.extend({
                    message: message,
                    center: false,
                    plain: false,
                    bgwhite: false,
                    top: undefined,
                    left: undefined
                }, scope.config);
                scope.messageArray = scope.conf.message.split("\n");
                //Count left
                $timeout(function () {
                    var widthCount = angular.element(element[0].querySelector('.relative-loader-container')).width();
                    var heightCount = angular.element(element[0].querySelector('.relative-loader-container')).height();
                    scope.leftTopCount = {
                        left: (scope.conf.left == undefined || scope.conf.left == null || scope.conf.left == '') ? "calc(50% - " + widthCount / 2 + "px)" : scope.conf.left + "px",
                        top: (scope.conf.top == undefined || scope.conf.top == null || scope.conf.top == '') ? "calc(50% - " + heightCount / 2 + "px)" : scope.conf.top+"px"
                    };
                });
				
                if (angular.isDefined(attrs.onCancel)) {
                	scope.cancelBtn = { title: $translate.instant("cancelBtn") };
                	scope.conf.isCancel = true;
                }

                scope.cancelCallback = function (e) {
                	scope.onCancel({ $event: e });
                };
            },
            templateUrl: 'shared/directives/smartGlobalLoader/smartGlobalLoader.html'
        };
    }]);
})();